const NPI_ADDRESS_INFORMATION_KEY = "npiAddressInformation";
const SKIP_CERTIFICATION_UPLOAD = "skipCertificationUpload";
const ONBOARDING_SUCCESS_KEY = "onboardingSuccess";
const ONBOARDING_SHIPPING_MODAL_SHOWN = "onboardingShippingModalShown";
const ACCOUNT_SETUP_MENU_TIME = "accountSetupMenuTime";
const CLASSIC_MIGRATION_MODAL_SHOWN = "classicMigrationModalShown";
const CATALOG_ASSIST_INFO_PANEL_DISMISSED = "catalogAssistInfoPanelDismissed";
const SEGMENTATION_QUESTIONS_COMPLETED = "segmentationQuestionsCompleted";
const ASSIST_INTEGRATION_REQUESTS = "assist_integration_requests";
const JOURNEYS_IN_OFFICE_ACTIVATION_MODAL_SEEN = "journeysInOfficeActivationModalSeen";
const ONBOARDING = "onboarding";
const STOREFRONT_ACTIVATION_MODAL_SEEN = "storefrontActivationModalSeen";
const ONBOARDING_STEP = "onboardingStep";

export {
  NPI_ADDRESS_INFORMATION_KEY,
  SKIP_CERTIFICATION_UPLOAD,
  ONBOARDING_SUCCESS_KEY,
  ONBOARDING_SHIPPING_MODAL_SHOWN,
  ACCOUNT_SETUP_MENU_TIME,
  CLASSIC_MIGRATION_MODAL_SHOWN,
  CATALOG_ASSIST_INFO_PANEL_DISMISSED,
  SEGMENTATION_QUESTIONS_COMPLETED,
  ASSIST_INTEGRATION_REQUESTS,
  JOURNEYS_IN_OFFICE_ACTIVATION_MODAL_SEEN,
  ONBOARDING,
  STOREFRONT_ACTIVATION_MODAL_SEEN,
  ONBOARDING_STEP,
};
